export default "__VITE_ASSET__DB5z4F5L__"